const CheckCircle2Icon = ({ className }) => {
    return (
        <div className={className}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                id="Check-Circle-2--Streamline-Flex"
            >
                <desc>
                    {'Check Circle 2 Streamline Icon: https://streamlinehq.com'}
                </desc>
                <g id="check-circle-2--checkmark-addition-circle-success-check-validation-add-form-tick">
                    <path
                        id="Vector"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12.124 5.00453c0.2484 0.72797 0.376 1.56209 0.376 2.49547 0 3.84 -2.16 6 -6 6s-6 -2.16 -6 -6 2.16 -6 6 -6c1.07619 0 2.02042 0.16966 2.82214 0.4984"
                        strokeWidth={1}
                    />
                    <path
                        id="Vector_2"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.5 6.4375 7.13636 10C8.8475 5.3304 10.2726 3.28134 13.5 0.5"
                        strokeWidth={1}
                    />
                </g>
            </svg>
        </div>
    );
};

export default CheckCircle2Icon;
